module.exports = __webpack_public_path__ + "img/crm_welcome.a13347ad.png";